import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { Toggle } from 'rsuite';

// components
import InputWrapper from './InputWrapper';

export const HookFormToggle = ({
  name,
  defaultValue = false,
  required = false,
  label = '',
  ...rest
}) => {
  // prevents issues where defaultValue is null
  const defaultInputValue = defaultValue || false
  const { setValue } = useFormContext();
  const {
    field: { onChange, onBlur, value, name: inputName, ref },
    fieldState: { error },
  } = useController({
    name,
    rules: { required },
    defaultValue: defaultInputValue,
  });

  useEffect(() => {
    setValue(name, defaultInputValue);
  }, [defaultInputValue]);

  return (
    <InputWrapper label={label} errorMessage={error?.message}>
      <Toggle
        onChange={onChange}
        onBlur={onBlur}
        defaultChecked={defaultInputValue}
        checked={value}
        inputRef={ref}
        name={inputName}
        {...rest}
      />
    </InputWrapper>
  );
};

HookFormToggle.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string,
  isTextArea: PropTypes.bool,
}

export default HookFormToggle;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/HookFormToggle.jsx